import type { ILayerProps } from '@/version-types';

export enum HistoryType {
    /** 转换为背景 */
    CONVERT_IMAGE_TO_BACKGROUND = 'convertImageToBackground',

    /** 扩展图片并更换背景 */
    EXPEND_IMAGE_AND_CHANGE_BG = 'expendImageAndChangeBg',
}

/** 转换为背景 */
export type IHistoryConvertImageToBackgroundData = {
    item: {
        oldLayer: ILayerProps;
        newBgLayer: ILayerProps;
        oldBgLayer: ILayerProps;
        layerIndex: number;
    };
};

/** 扩展图片并更换背景 */
export type IHistoryExpendImageAndChangeBgData = {
    item: {
        newLayer: ILayerProps;
        oldLayer: ILayerProps;
        oldBgLayer: ILayerProps;
        newBgLayer: ILayerProps;
        /** 协同撤销或重做时基于原始操作生成的字段差异 */
        diffInfo?: Record<string, object>;
    };
};
